import { Controller } from "@hotwired/stimulus";

// Inline "Respond" disclosure on an event log entry: the quiet Respond control
// swaps for a composer (textarea + Approve/Decline) that posts to the source's
// approve/decline endpoint. Cancel restores the control.
export class EventLogRespondController extends Controller {
  static targets = ["trigger", "composer"];

  open(event) {
    event.preventDefault();
    this.triggerTarget.classList.add("d-none");
    this.composerTarget.classList.remove("d-none");
    this.composerTarget.querySelector("textarea")?.focus();
  }

  cancel(event) {
    event.preventDefault();
    this.composerTarget.classList.add("d-none");
    this.triggerTarget.classList.remove("d-none");
    const textarea = this.composerTarget.querySelector("textarea");
    if (textarea) textarea.value = "";
    this.triggerTarget.querySelector("button")?.focus();
  }
}
